import { GROUP_LIST, USR_LIST, GROUP_GET, STORE_LIST, GROUP_BY_STORES_GET } from './types'
import { Api } from '../../components/Api'
import { toast } from 'react-toastify';


export const storesList = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/groups/stores_by_company/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (!response.data?.success) {
                    return;
                }

                dispatch({
                    type: STORE_LIST,
                    payload: response.data.data || []
                });
            }).catch(err => {
                if (err.response) {
                } else {
                    alert(err.message)
                }
            });
    }
}

export const rolesList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/groups/getRoles',
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                dispatch({
                    type: USR_LIST,
                    payload: response.data.data
                })
            }).catch(err => {
                if (err.response) {
                } else {
                    alert(err.message)
                }
            });
    }
}

export const groupList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/groups/getAllGroups',
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                dispatch({
                    type: GROUP_LIST,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                } else {
                    alert(err.message)
                }
            });
    }
}

export const getStoreByGroup = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/groups/getGroupStores/${id}`,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                dispatch({
                    type: GROUP_BY_STORES_GET,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                } else {
                    alert(err.message)
                }
            });
    }
}

export const addGroupStore = (data: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.post('/groups/add', data,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                window.location.href = "/groups";

            }).catch(err => {
                if (err.response) {
                    let error;
                    if (typeof (err.response.data.message) === "string") {
                        if (err.response.data.code === "ER_DUP_ENTRY") {
                            error = "Group Name Already Exist"
                            alert(error);
                        } else {
                            error = err.response.data.message;
                        }
                    } else if (typeof (err.response.data.message) === "object") {
                        error = err.response.data.message[0].replace(/_/g, " ");
                    }
                } else {
                    alert(err.message)
                }
            });
    }
}
export const getGroup = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/groups/get/${id}`,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                dispatch(storesList(response.data.data.company.id))
                dispatch({
                    type: GROUP_GET,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                    const message = err.response.data.message;
                    // If message is an array → show each error
                    if (Array.isArray(message)) {
                        message.forEach((msg) => toast.error(msg));
                    }
                    // If it's a single string → show once
                    else if (typeof message === "string") {
                        toast.error(message);
                    }
                    else {
                        toast.error("Something went wrong.");
                    }
                } else {
                    toast.error(err.message);
                }
            });
    }
}
export const updateGroup = (id: any, data: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.put(`/groups/update/${id}`, data,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                window.location.href = "/groups";

            }).catch(err => {
                if (err.response) {
                    const message = err.response.data.message;
                    // If message is an array → show each error
                    if (Array.isArray(message)) {
                        message.forEach((msg) => toast.error(msg));
                    }
                    // If it's a single string → show once
                    else if (typeof message === "string") {
                        toast.error(message);
                    }
                    else {
                        toast.error("Something went wrong.");
                    }
                } else {
                    toast.error(err.message);
                }
            });
    }
}
export const deleteGroup = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');

        Api.put(`/groups/delete/${id}`, {}, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    toast.success("Group deleted successfully!", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                    setTimeout(() => {
                        window.location.href = "/groups";
                    }, 1500);
                } else {
                    toast.error(response.data.message || "Failed to delete group", {
                        position: "top-right",
                        autoClose: 4000,
                    });
                }
            })
            .catch(err => {
                if (err.response) {
                    toast.error(err.response.data.message || "Something went wrong!", {
                        position: "top-right",
                        autoClose: 4000,
                    });
                } else {
                    toast.error(err.message, {
                        position: "top-right",
                        autoClose: 4000,
                    });
                }
            });
    };
};